import { render, staticRenderFns } from "./CardStockProduct.vue?vue&type=template&id=0bd145a6"
import script from "./CardStockProduct.vue?vue&type=script&lang=js"
export * from "./CardStockProduct.vue?vue&type=script&lang=js"
import style0 from "./CardStockProduct.vue?vue&type=style&index=0&id=0bd145a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports